import request from '../libs/request';
import dateFormat from 'date-fns/format';
import saveAs from 'file-saver';

const res = 'Permission';

export default {
  query() {
    return request({
      url: `api/${res}/query`,
      method: 'get',
      params: {
        clientType: 'Admin'
      }
    });
  },
  queryByRoleID(roleID, clientType) {
    return request({
      url: `api/${res}/queryByRoleID`,
      method: 'get',
      params: {
        roleID,
        clientType
      }
    });
  },
  queryRouter() {
    return request({
      url: `api/${res}/queryRouter`,
      method: 'get',
      params: {
        clientType: 'Admin'
      }
    });
  },
  async exportFile(ids) {
    const result = await request({
      url: `api/${res}/exportFile`,
      method: 'post',
      responseType: 'blob',
      data: {
        ids
      }
    });

    const blob = new Blob([result], {
      type: 'application/octet-stream'
    });
    saveAs(blob, 'Permission-' + dateFormat(new Date(), 'yyyyMMddHHmmss') + '.pms');
  }
};
